import { SidePanelStyles } from '@client/style/style.constants';
import { createResizeDragHook } from '@client/hooks/use-resize-drag.hook';

export const DESIGN_RIGHT_PANEL_WIDTH_VAR = '--design-right-panel-width';
export const DESIGN_COLLAPSED_TABS_INSET_VAR = '--design-collapsed-tabs-inset';

/**
 * Shared width for Design's right panel. The handle sits on the panel's left
 * edge, so dragging left grows the panel. Widths under `collapseBelow` snap
 * shut; a double-click collapses to `min` and a tab click restores the last
 * open width.
 */
export const designRightPanelResizeOptions = {
  storageKey: 'designRightPanelWidth',
  min: 0,
  maxRatio: 0.5,
  defaultWidth: SidePanelStyles.WIDTH,
  growDirection: 'left',
  collapseBelow: 200,
} as const;

export const {
  useResizeWidth: useDesignRightPanelWidth,
  useResizeHandle: useDesignRightPanelResizeHandle,
  useExpandWidth: useExpandDesignRightPanel,
  useCollapseWidth: useCollapseDesignRightPanel,
} = createResizeDragHook(designRightPanelResizeOptions);
